/* ==========================================================================
   CounterRxjs > Client > Prototype
   ========================================================================== */

/* Modules */
const { Store } = require('@bluekiri/alexandria/helpers/state');

const { actions, types } = require('./store/actions');
const { reducer } = require('./store/reducer');

const { initButtons, destroyButtons } = require('./buttons');

const { updateUI } = require('./ui');

const configuration = require('./config');

/* Prototype */
const prototype = {
    /* Setup store */
    setupStore() {
        if (this.store) return this;

        /* Create store */
        this.store = new Store({
            counter: reducer
        });

        return this;
    },
    /* Actions */
    setupActions() {
        if (this.actions) return this;

        this.actions = {
            destroy: () => this.store.dispatch(actions.destroy()),
            display: () => this.store.dispatch(actions.display()),
            hide: () => this.store.dispatch(actions.hide()),
            resetStatus: () => this.store.dispatch(actions.resetStatus()),
            setError: () => this.store.dispatch(actions.setError()),
            setValid: () => this.store.dispatch(actions.setValid()),
            disable: () => this.store.dispatch(actions.disable()),
            enable: () => this.store.dispatch(actions.enable()),
            set: payload => this.store.dispatch(actions.set(payload))
        };

        return this;
    },
    /* Reactions */
    setupReactions() {
        if (this.reactions) return this;

        this.reactions = {
            destroy: this.store.subscribe((state, action) => {
                if (action.type !== types.DESTROY) return;

                /* Buttons */
                destroyButtons(this);

                /* Unsubscribe */
                this.unsubscribe();

                /* Remove from DOM */
                this.element.parentNode.removeChild(this.element);

                /* Clean references */
                [...Object.keys(this)].forEach(key => delete this[key]);
            }),
            display: this.store.subscribe((state, action) => {
                if (action.type !== types.DISPLAY) return;

                this.element.classList.remove(configuration().css.hidden);
            }),
            hide: this.store.subscribe((state, action) => {
                if (action.type !== types.HIDE) return;

                this.element.classList.add(configuration().css.hidden);
            }),
            resetStatus: this.store.subscribe((state, action) => {
                if (action.type !== types.RESET_STATUS) return;

                this.element.classList.remove(configuration().css.error);
                this.element.classList.remove(configuration().css.valid);
            }),
            setError: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_ERROR) return;

                this.element.classList.remove(configuration().css.valid);
                this.element.classList.add(configuration().css.error);
            }),
            setValid: this.store.subscribe((state, action) => {
                if (action.type !== types.SET_VALID) return;

                this.element.classList.remove(configuration().css.error);
                this.element.classList.add(configuration().css.valid);
            }),
            disable: this.store.subscribe((state, action) => {
                if (action.type !== types.DISABLE) return;

                this.element.classList.add(configuration().css.disabled);
            }),
            enable: this.store.subscribe((state, action) => {
                if (action.type !== types.ENABLE) return;

                this.element.classList.remove(configuration().css.disabled);
            })
        };

        return this;
    },
    /* Subscribe */
    subscribe() {
        if (this.subscriptions) this.unsubscribe();

        this.subscriptions = {};

        return this;
    },
    /* Unsubscribe */
    unsubscribe() {
        if (!this.subscriptions) return this;

        [...Object.keys(this.subscriptions)].forEach(key => this.subscriptions[key].unsubscribe());

        return this;
    },
    /* Start */
    start() {
        if (!this.config.start) return this;

        const { value } = this.config;

        /* Update State initial */
        updateUI(value, this);

        /* Sync */
        if (value < 1) {
            return this;
        }

        /* Set payload */
        this.actions.set(value);

        return this;
    },
    /* Init */
    init() {
        if (!this.config.init) return this;

        /* Setup store */
        this.setupStore();

        /* Setup actions */
        this.setupActions();

        /* Setup reactions */
        this.setupReactions();

        /* Subscribe */
        this.subscribe();

        /* Buttons */
        initButtons(this);

        /* Start */
        this.start();

        return this;
    }
};

/* Exports */
module.exports = prototype;
